export default function initAboutReadMore() {
   const readMoreBtn = document.querySelector('.js-about-read-more');
   const hiddenText = document.querySelector('.js-about-hidden-text');

   if (!readMoreBtn || !hiddenText) return;

   readMoreBtn.addEventListener('click', () => {
      // Toggle the expanded class
      hiddenText.classList.toggle('is-expanded');

      // Update the button text and icon based on the state
      if (hiddenText.classList.contains('is-expanded')) {
         readMoreBtn.innerHTML = 'Leer menos <span class="cdr-about__read-more-icon">▼</span>';
      } else {
         readMoreBtn.innerHTML = 'Leer más <span class="cdr-about__read-more-icon">▼</span>';
      }
   });
}
